import loaderStyles from './core/template/loader.less?inline';

export class Loader {
    constructor(canvasId: string) {
        const canvasElement = document.getElementById(canvasId);
        if(canvasElement){
            const loader = document.createElement("div");
            loader.setAttribute("id", "mainLoader");
            loader.setAttribute("class", 'loader loader--visible loader--absolute');
            loader.innerHTML = `
            <style>${loaderStyles}</style>
            <div class="loadingContainer">
                <div id="mainLoaderText" class="loader__text"></div>
                <img src="./assets/loader/logo.png" class="eyeLogo" />
                <img src="./assets/loader/loader_play.png" class="clickToStart" />
                <span class="clickToStartText"></span>
                <img src="./assets/loader/wheel_shine_part.png" class="wheelShine pos-0" />
                <img src="./assets/loader/wheel_shine_part.png" class="wheelShine pos-1" />
                <img src="./assets/loader/wheel_shine_part.png" class="wheelShine pos-2" />
                <img src="./assets/loader/full_line-cropped.png" class="loadingLine" />
            </div>`
            canvasElement.after(loader);
        }
    }
}